
import { BrowserRouter as Router, Route,Switch } from "react-router-dom";
import PublicLayout from "../layout/PublicLayout";


const RoutesComponent = () => {
  return (
  
      <Router>
        <Route  path="/" component={PublicLayout}></Route>      
      </Router>
    
  );
};

export default RoutesComponent;